'use strict';

(function () {
  'use strict';

  angular.module('msWidgets').directive('msWidgetToolsSleepDiary', msWidgetToolsSleepDiary);

  function msWidgetToolsSleepDiary() {
    var directive = {
      templateUrl: 'widgets/templates/tools/sleep-diary.html',
      restrict: 'E',
      controller: WidgetToolsSleepDiaryController
    };
    return directive;
  }

  WidgetToolsSleepDiaryController.$inject = ['$scope', 'NotifyingSvc', '$translate', '$log'];

  function WidgetToolsSleepDiaryController($scope, NotifyingSvc, $translate, $log) {
    this.$onInit = activate;
    $scope.openDiaryModal = _openDiaryModal;

    function activate() {
      $log.debug('WidgetToolsSleepDiaryController activate');
    }

    function _openDiaryModal() {
      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.OPEN_MODAL, {
        templateUrl: 'sleep/pages/sleep-entry-modal.html',
        controller: 'SleepEntryModalCtrl',
        inputs: {},
        closeCallback: modalCallback
      });
    }

    function modalCallback() {
      $log.debug('close modal callback');
    }
  }
})();